export const environment = {
    production: false,
    uploadBaseUrl: 'http://dev-samiksha.carufus.com/uploads/', 
    //ORDERPOS_CLOUD_BASE_URL : "https://captain.bnhl.in/opdotnet",
    ORDERPOS_CLOUD_BASE_URL : "https://captain.bnhl.in/opdotnet",
    ORDERPOS_CLOUD_DEV_BASE_URL : "https://captain.bnhl.in/orderposcoreallconnection",
    SPINTA_BASE_URL : "https://orderpos.bnhl.in",
    API_COMMON_MASTER_BASE_URL: "https://erpapi.bnhl.in/commonmasterapi/api",
    API_PO_BASE_URL: "https://gvgc.bnhl.in",
    API_PO_ADMIN_URL: "https://gvgc.bnhl.in/PartTimeAdminPortalWebAPI/api/",
    BASE_URL: 'https://erpapi.bnhl.in/BussinessInsights_v10/api',
//     API_OPS_BASE_URL: "https://erpapi.bnhl.in/opsauthwebapi/api",
//     API_INSIGHTS_BASE_URL: "https://erpapi.bnhl.in/InsightsAuthAPI/api",
//    AUTH_ENDPOINT: "https://erpapi.bnhl.in/internalauth/connect/token",
//     API_OPS_AUDIT_BASE_URL: "https://erpapi.bnhl.in/opsauthwebapi",
//      API_HELPDESK_BASE_URL_V2 : "https://erpapi.bnhl.in/helpdeskv3/api",
//     API_HELPDESK_DEV_BASE_URL_V2 : "https://erpapi.bnhl.in/helpdeskv3/api",

    // UAT Environment
    AUTH_ENDPOINT: "https://sit.bnhl.in/internalauth_uat/connect/token",
    API_OPS_AUDIT_BASE_URL: "https://sit.bnhl.in/opsauthwebapi",
    API_OPS_BASE_URL: "https://sit.bnhl.in/opsauthwebapi/api",
    API_INSIGHTS_BASE_URL: "https://sit.bnhl.in/InsightsAuthAPI/api",
    API_HELPDESK_BASE_URL_V2 : "https://sit.bnhl.in/helpdeskv3_dev/api",
    API_HELPDESK_DEV_BASE_URL_V2 : "https://sit.bnhl.in/helpdeskv3_dev/api",
    OPS_Dynamic_API_BASE_URL: "https://erpapi.bnhl.in/UATAPI/api/OPS",

    LEAD_URL: 'https://leads.bnhl.in/',
    
   tableHygieneConfig: {
        templateId: 360,
        deviceId: 1
    },
    firebaseConfigQQT: {
        apiKey: 'AIzaSyBJexFv5QnG2mZYe_dYK_Jao_os1GV26EQ',
        authDomain: 'bbqn-ops-staging.firebaseapp.com',
        databaseURL: 'https://bbqn-ops-staging.firebaseio.com',
        projectId: 'bbqn-ops-staging',
        storageBucket: 'bbqn-ops-staging.appspot.com',
        messagingSenderId: '510009598366',
        appId: '1:510009598366:web:d6f86c171111346281368f'
    },
    firebaseConfigAudit: {
        apiKey: 'AIzaSyDwmHws9NVBQR_B0oIFPXmzv_2VKI9nwdo',
        authDomain: 'qualityaudit-dev.firebaseapp.com',
        databaseURL: 'https://qualityaudit-dev.firebaseio.com',
        projectId: 'qualityaudit-dev',
        storageBucket: 'qualityaudit-dev.appspot.com',
        messagingSenderId: '739989484450',
        appId: '1:739989484450:android:8dcaf5f1032f1e36ab38fb'
    },
    awsS3: {
        AWSAccessKey: 'AKIAQWSSYCXXY7KQMAF4',
        AWSFolderPath: 'S3-Bucket,Aditya,FY2021-22,Jan-March2021,FY2021-22/ERP_FTP',
        AWSSecretKey: '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',
        uploadTempBucket: 'barbequenation-document/Temp',
        uploadBucket: 'barbequenation-document/POTracker',
        uploadGHBucket: 'barbequenation-document',
        uploadEMBucket: 'barbequenation-document',
          uploadTraningBucket: 'orderpos',
        region: 'ap-south-1'
    },
    ServiceConfiguration: {
        AWSS3: {
        "BucketName": "part-time-app",
        "SecretAccessKey": "sgtHFj/HZ2gD3OhirxdG8/7XnG2BsDN/p/3+v0ja",
        "AccessKeyId": "AKIAQWSSYCXXY7KQMAF4"
        }
    },
};
